import DinesCommandPalette from "@dinesapp/dines-ui/components/CommandPalette/CommandPalette";
import CommandPaletteViewModel from "../Models/CommandPaletteViewModel";

const CommandPalette = () => {
  const vm = CommandPaletteViewModel();

  return (
    <DinesCommandPalette
      commands={vm.commands}
      onSelect={vm.onSelect}
      groupOrder={vm.groupOrder}
    />
  );
};

export default CommandPalette;
